import { NODE_PARAGRAPH as n, NODE_HEADING as t, NODE_CODEBLOCK as e, NODE_QUOTE as r, NODE_OL as o, NODE_UL as i, NODE_LI as l, NODE_HR as u, NODE_BR as d } from "../../node_modules/storyblok-rich-text-react-renderer/dist/index.es.js";
var c = function c(_c, a) {
    var f;
    return "text" === _c.type ? _c.text : [n, t, e, r, o, i, l, u, d].includes(_c.type) ? (null === (f = _c.content) || void 0 === f ? void 0 : f.length) ? v(_c.content, a) + (a ? "\n\n" : " ") : "" : null;
  },
  v = function v(n, t) {
    return n.map(function (n) {
      return c(n, t);
    }).filter(function (n) {
      return null !== n;
    }).join("").replace(/[^\S\r\n]{2,}/g, " ");
  },
  a = function a(n, t) {
    var e,
      r = (void 0 === t ? {} : t).addNewlines;
    return (null === (e = null == n ? void 0 : n.content) || void 0 === e ? void 0 : e.length) ? v(n.content, void 0 === r || r) : "";
  };
export { a as getPlainText };